angular.module('app').directive('adminSelect', function() {
    return {
        restrict: 'A',
        priority: -1,
        compile: function(element, attrs) {
            var containerClass = attrs.mdContainerClass || '';
            var selectIcon = element[0].querySelector('.md-select-icon');

            attrs.$set('mdContainerClass', (containerClass + ' admin-select-menu').trim());

            if (selectIcon) {
                var arrowIcon = document.createElement('md-icon');

                arrowIcon.className = 'admin-select-arrow-icon';
                arrowIcon.setAttribute('md-svg-icon', 'down-arrow');
                arrowIcon.setAttribute('aria-hidden', 'true');

                angular.element(selectIcon).addClass('admin-select-icon');
                selectIcon.appendChild(arrowIcon);
            }
        }
    };
});
